import {SubNav, Box} from '@primer/react-brand/esm'
import {isLink, isLinkGroup} from '../../types'
import type {FlexSuiteSubNavProps} from './types'

export function FlexSuiteSubNav({subNav}: FlexSuiteSubNavProps) {
  const {subNavHeading, subNavSubHeading, subNavLinks, subNavCta} = subNav.fields

  return (
    <>
      <SubNav>
        {subNavHeading && <SubNav.Heading href={subNavHeading.fields.href}>{subNavHeading.fields.text}</SubNav.Heading>}

        {subNavSubHeading && (
          <SubNav.SubHeading href={subNavSubHeading.fields.href}>{subNavSubHeading.fields.text}</SubNav.SubHeading>
        )}

        {subNavLinks?.map(
          linkOrLinkGroup =>
            (isLink(linkOrLinkGroup) && (
              <SubNav.Link key={linkOrLinkGroup.sys.id} href={linkOrLinkGroup.fields.href}>
                {linkOrLinkGroup.fields.text}
              </SubNav.Link>
            )) ||
            (isLinkGroup(linkOrLinkGroup) && (
              <SubNav.Link key={linkOrLinkGroup.sys.id} href="">
                {linkOrLinkGroup.fields.label}

                <SubNav.SubMenu variant="dropdown">
                  {linkOrLinkGroup.fields.links.map(link => (
                    <SubNav.Link key={link.sys.id} href={link.fields.href}>
                      {link.fields.text}
                    </SubNav.Link>
                  ))}
                </SubNav.SubMenu>
              </SubNav.Link>
            )),
        )}

        {subNavCta && <SubNav.Action href={subNavCta.fields.href}>{subNavCta.fields.text}</SubNav.Action>}
      </SubNav>
      <Box paddingBlockStart={{narrow: 112, wide: 64}} />
    </>
  )
}
